import { useContext } from 'react';
import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { API } from '@trinity/chat';
import { QuantAnalysisAPIContext } from '../contexts/QuantAnalysisAPIContext';

type Props = {
  projectId: number;
  quantAnalysisId: number;
  versionNumber: number;
};

type Data = API.ProjectsQuantAnalysis.GetProjectQuantAnalysis.Response;
type QueryKey = readonly [string, Props];
type Options = Omit<UseQueryOptions<Data, Error, Data, QueryKey>, 'queryKey' | 'queryFn'>;

export const useProjectQuantAnalysisQuery = (props: Props, options?: Options) => {
  const apiContext = useContext(QuantAnalysisAPIContext);

  if (!apiContext) {
    throw new Error(
      'useProjectQuantAnalysisQuery must be used within a QuantAnalysisAPIProvider',
    );
  }

  const queryKey = ['project:quant-analysis', { projectId: props.projectId, quantAnalysisId: props.quantAnalysisId, versionNumber: props.versionNumber }] as const;

  const query = useQuery({
    queryKey: queryKey,
    queryFn: async () => {
      return apiContext.getProjectQuantAnalysis({
        projectId: props.projectId,
        quantAnalysisId: props.quantAnalysisId,
        versionNumber: props.versionNumber,
      });
    },
    ...options,
  });

  return query;
};